export enum IdAndSizeType {
  IDSIZECART = 'IDSIZECART',
  IDSIZECHECKOUT = 'IDSIZECHECKOUT',
  IDSIZEPRODUCTCARD = 'IDSIZEPRODUCTCARD',
  IDSIZEPRODUCTMERCHANDISE = 'IDSIZEPRODUCTMERCHANDISE',
  IDSIZESEARCHCARD = 'IDSIZESEARCHCARD',
  IDSIZEPROMOTION = 'IDSIZEPROMOTION',
  IDSIZEDISPLAYNONE = 'IDSIZEDISPLAYNONE',
  ID_SIZE_APOINT_CARD = 'ID_SIZE_APOINT_CARD',
  ID_SIZE_FREE_CART_CARD = 'ID_SIZE_FREE_CART_CARD',
  ID_SIZE_VARIANT_DRAWER = 'ID_SIZE_VARIANT_DRAWER',
  ID_SIZE_CART_MOBILE_VARIANT = 'ID_SIZE_CART_MOBILE_VARIANT',
}
